import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { CalcScreen, CategoryCard } from '../../components/shell';
import { C, FONT, SP } from '../../theme/tokens';

type TABCategory = {
  title: string;
  description: string;
  emoji: string;
  screen: string;
};

const TAB_CATEGORIES: TABCategory[] = [
  {
    title: 'Air',
    description: 'Airflow, temperature, heat transfer, and fan equations',
    emoji: '🌬️',
    screen: 'TABAir',
  },
  {
    title: 'Hydronic',
    description: 'Pump laws, efficiency, heat transfer, and boiler calculations',
    emoji: '💧',
    screen: 'TABHydronic',
  },
  {
    title: 'Electrical',
    description: 'Power, electrical relationships, and motor calculations',
    emoji: '⚡',
    screen: 'TABElectrical',
  },
];

const TABOverviewScreen = () => {
  const navigation = useNavigation();

  return (
    <CalcScreen title="TAB Procedures" subtitle="Testing, adjusting, balancing">
      <Text style={styles.sectionLabel}>Calculation Categories</Text>
      {TAB_CATEGORIES.map((category) => (
        <CategoryCard
          key={category.screen}
          emoji={category.emoji}
          title={category.title}
          description={category.description}
          cta={`View ${category.title} →`}
          onPress={() => navigation.navigate(category.screen as never)}
        />
      ))}
    </CalcScreen>
  );
};

const styles = StyleSheet.create({
  sectionLabel: {
    fontFamily: FONT.sans,
    fontSize: 12,
    color: C.dim,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    marginBottom: SP.sm,
  },
});

export default TABOverviewScreen;
